// SARKY: a tap/click anywhere inside a product-card colour-swatch row must
// never trigger the card's own click-to-navigate handler
// (assets/product-card.js, ProductCard#navigateToProduct). Horizon's own
// handler already excludes clicks whose event.target sits inside a
// <label>/<input>/etc, which covers a precise click -- but a real touch tap
// can resolve its target a few px off, landing on the row's own background
// (the gap/padding inside .sarky-card-meta__swatches, not on the <label>
// itself), which is NOT excluded by that check and DOES bubble up to
// navigateToProduct, causing an unwanted PDP navigation from what looks like
// "tapping the swatch" on a physical device.
//
// Delegated on document in the CAPTURE phase, so it runs before
// <product-card>'s own bubble-phase listener, and covers every current AND
// future swatch row (infinite scroll, quick-add re-renders) without ever
// needing to re-bind. Empirically verified (headless Chrome, real
// Input.dispatchMouseEvent clicks) that stopping propagation here does NOT
// block the label's native "click activates its input" default action -- the
// radio still gets checked normally; this only stops the click from
// continuing on to <product-card>. The variant-update/variant-selected
// CustomEvents that swatches-variant-picker-component (assets/product-card.js)
// dispatches afterwards to drive the card's own image-switching are a
// different event type entirely, dispatched separately from this click, so
// they are completely unaffected -- media switching keeps working exactly as
// before.
//
// This file is loaded via a <script type="module"> tag inside
// blocks/swatches.liquid, once per rendered meta row. ES module specifiers
// are deduplicated by the browser per absolute URL, so this body only ever
// executes once per page regardless of how many product cards render it --
// the same pattern already used by snippets/sarky-header-search.liquid.
document.addEventListener(
  'click',
  (event) => {
    if (event.target instanceof Element && event.target.closest('.sarky-card-meta__swatches')) {
      event.stopPropagation();
    }
  },
  true,
);
